import { formatViews, formatViewsExact } from '../utils/formatViews'
import styles from './InfoButton.module.css'

interface Props {
  open: boolean
  onToggle: () => void
  title: string
  description?: string
  views: number | null
}

export function InfoButton({ open, onToggle, title, description, views }: Props) {
  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={`${styles.btn} ${open ? styles.active : ''}`}
        onClick={onToggle}
        aria-label="Video info"
        aria-expanded={open}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden>
          <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
          />
        </svg>
      </button>

      {open && (
        <div className={styles.panel} role="dialog" aria-label="Video information">
          <p className={styles.title}>{title || 'Video'}</p>
          {description ? <p className={styles.desc}>{description}</p> : null}
          <div className={styles.stat}>
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
              <path
                fill="currentColor"
                d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
              />
            </svg>
            <div>
              <strong>{views == null ? '—' : formatViews(views)}</strong>
              <span> views{views != null ? ` (${formatViewsExact(views)})` : ''}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
